module.exports = __webpack_public_path__ + "static/img/submit_icon.ee494c0e.svg";